import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { GlobalVariable } from 'src/app/providers/global/global';
import { ICancellationDefectPatchRequest } from 'src/app/providers/models/defect-vehicle.models';
import { Defect, DefectRepairer, DefectStatus, IDefectNote, IDefectStatus } from 'src/app/providers/models/user-cust-models';
import { RestProvider } from 'src/app/providers/rest/rest';



@Component({
  selector: 'app-modal-cancel-defect',
  templateUrl: './modal-cancel-defect.component.html',
  styleUrls: ['./modal-cancel-defect.component.scss'],
})
export class ModalCancelDefectComponent implements OnInit {
  isLoading = false;
  searchMessage = '';
  defectStatusObject = DefectStatus;
  cancellation: ICancellationDefectPatchRequest = {
    id: null,
    cancellation_reason: null,
    cancellation_reason_description: '',
    status: null,
    vor: false
  }

  // Data passed in by componentProps
  @Input() currentDefect: Defect | null = null;


  constructor(
    private modalCtrl: ModalController,
    private global: GlobalVariable,
    private rest: RestProvider,
    private navCtrl: NavController,
  ) { }
  name: string;
  cancellationReasonOptions: {label: string, value: number} = null;

  ngOnInit() {
    console.log('ModalVehicleDefectsComponent ngOnInit');

    // Get the defects from API
    this.getCancellationReasons();
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    return this.modalCtrl.dismiss(this.name, 'confirm');
  }

  private getCancellationReasons() {
    // console.log('getting Defects...', this.depots);
    this.isLoading = true;
    const wantedSearches = [];
    
    console.log('Cancellation reasons: ', wantedSearches);

    // const depots = this.depotFilter.value !== 'none' ? [this.depotFilter.value] : this.depots.map((x) => x = x.value).slice(1, this.depots.length);

    this.rest.DefectCancellationReasonsGet().then((res: any) => {

      let cancellations = res.results;
      if (res.results && res.results.length > 0) {
        this.cancellationReasonOptions = cancellations.map((c) => { 
          return {value: c.id, label: c.reason}
        });
      }
      
      console.log('cancellation reasons Fetched', res);
      this.isLoading = false;

      if (cancellations.length === 0) {
        this.searchMessage = 'No defects found';
      }
    })
      .finally(() => {
        // if (this.refresher) {
        //   this.refresher.complete();
        // }
      });
  }

  public onCancellationReasonChange(event) {
    debugger;
    if (event) {
      this.cancellation.cancellation_reason = event;
    }
  }

  public click_cancel() {
    debugger
    this.isLoading = true;
    const uuid = this.currentDefect.uuid;
    const payload: ICancellationDefectPatchRequest = {...this.cancellation,
      id: this.currentDefect['id'],
      status: DefectStatus.Cancel.id,
      vor: false
    }
    // Patch the defect with cancellation
    this.rest.CancelDefectUpdate(payload, this.currentDefect.uuid).then((result) => {
    // this.rest.DefectCancel(this.currentDefect).then((result) => {
     debugger
      this.isLoading = false;
      this.global.toast('Defect has been void');
      
      // Update the actions on defect
      this.sendDefectStatusActionTrail(this.currentDefect);
      this.confirm();

    }).catch((error) => {
      console.log('catch((error) ', error);
      this.isLoading = false;
    });
    
    ;
  }

  private sendDefectStatusActionTrail(defect: Defect) {
    const actionComment = 'Defect has been void'; //this.global.getDefectStatusActionTrailText(defect);
    debugger
    // if (actionComment !== '') {
      const defectAction: IDefectNote = {
        defect: defect.uuid,
        comment: actionComment,
        user_generated: false,
        files: []
      }
      this.rest.DefectNotePost(defectAction).then((result: IDefectNote) => {
       
      }).catch((error) => {
        this.global.toast('Failed to post note.');
      });
    // }
  }

} 

